var _sodipodiNamedview, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrkfstLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1145.8224,
    zoomAndPan: "magnify",
    viewBox: "0 0 859.36679 312.35938",
    height: 416.47919,
    preserveAspectRatio: "xMidYMid",
    id: "svg38",
    sodipodiDocname: "brkfst app logo.svg",
    inkscapeVersion: "1.3 (0e150ed6c4, 2023-07-21)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview38",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: "true",
    inkscapeDeskcolor: "#d1d1d1",
    showborder: "true",
    inkscapeZoom: 1.0341667,
    inkscapeCx: 584.52861,
    inkscapeCy: 208.38034,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1001,
    "inkscapeWindow-x": -9,
    "inkscapeWindow-y": -9,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg38"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "11f41da5a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.839844,31.320312 H 324.20312 V 343.67969 H 11.839844 Z m 0,0",
    clipRule: "nonzero",
    id: "path1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c44720c631"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 324.20312,187.5 c 0,86.25391 -69.92968,156.17969 -156.17968,156.17969 -86.253909,0 -156.183596,-69.92578 -156.183596,-156.17969 0,-86.25391 69.929687,-156.179688 156.183596,-156.179688 86.25,0 156.17968,69.925778 156.17968,156.179688",
    clipRule: "nonzero",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5d70f5a330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.933594,83 H 246.11328 V 292 H 89.933594 Z m 0,0",
    clipRule: "nonzero",
    id: "path3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ed6c4a7dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 166.26562,83.382812 c -28.28515,0.453126 -76.332026,48.062498 -76.332026,128.152348 0,25.98046 14.019536,80.09375 76.085936,80.09375 60.07031,0 80.09375,-43.29297 80.09375,-80.09375 0,-75.75782 -44.05078,-127.699222 -79.83594,-128.152348",
    clipRule: "nonzero",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "59af2b0735"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.02344,165.53906 H 219 v 51.2461 h -50.97656 z m 0,0",
    clipRule: "nonzero",
    id: "path5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1b4a0bcd4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 218.31641,216.13672 c 0,-27.76953 -22.51172,-50.28125 -50.28125,-50.28125 v 50.28125 z m 0,0",
    clipRule: "nonzero",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fdaf29bd8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.02344,216 H 219 v 50.80859 h -50.97656 z m 0,0",
    clipRule: "nonzero",
    id: "path7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d9855d526"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 168.02344,266.40625 c 27.76953,0 50.28125,-22.51172 50.28125,-50.28125 h -50.28125 z m 0,0",
    clipRule: "nonzero",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "01e1a54c8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 117,216 h 51.02344 v 50.80859 H 117 Z m 0,0",
    clipRule: "nonzero",
    id: "path9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63163ab9b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 117.72656,216.13672 c 0,27.76953 22.51172,50.28125 50.28125,50.28125 v -50.28125 z m 0,0",
    clipRule: "nonzero",
    id: "path10"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#11f41da5a4)",
    id: "g12",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c44720c631)",
    id: "g11"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2d6bff",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path11"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5d70f5a330)",
    id: "g14",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ed6c4a7dd)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path12"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59af2b0735)",
    id: "g16",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1b4a0bcd4)",
    id: "g15"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbd405",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path14"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fdaf29bd8b)",
    id: "g18",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d9855d526)",
    id: "g17"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2d6bff",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path16"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#01e1a54c8d)",
    id: "g20",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63163ab9b8)",
    id: "g19"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5abd",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path18"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g23",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.92154,263.42064)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 36.65625,-26.421875 c 2.78125,3.375 5.804688,5.761719 9.078125,7.15625 3.28125,1.386719 6.738281,2.078125 10.375,2.078125 3.78125,0 7.175781,-0.675781 10.1875,-2.03125 3.007813,-1.351562 5.570313,-3.46875 7.6875,-6.34375 2.125,-2.882812 3.75,-6.5625 4.875,-11.03125 1.125,-4.46875 1.6875,-9.816406 1.6875,-16.046875 0,-11.1875 -1.855469,-19.28125 -5.5625,-24.28125 -3.710937,-5 -9.039063,-7.5 -15.984375,-7.5 -4.710938,0 -8.820312,1.078125 -12.328125,3.234375 -3.5,2.148438 -6.839844,5.171875 -10.015625,9.078125 z m 0,-62.96875 c 4.101562,-4.300781 8.648438,-7.722656 13.640625,-10.265625 5,-2.55078 10.710937,-3.82813 17.140625,-3.82813 5.894531,0 11.207031,1.15625 15.9375,3.46875 4.738281,2.312505 8.78125,5.64063 12.125,9.98438 3.34375,4.335938 5.90625,9.578125 7.6875,15.734375 1.78906,6.15625 2.6875,13.078125 2.6875,20.765625 0,8.273438 -1.02734,15.789062 -3.07812,22.546875 -2.05469,6.75 -4.98438,12.527344 -8.79688,17.328125 -3.804688,4.804688 -8.386719,8.527344 -13.75,11.171875 -5.367188,2.644531 -11.324219,3.96875 -17.875,3.96875 -3.179688,0 -6.058594,-0.3125 -8.640625,-0.9375 -2.585937,-0.625 -4.96875,-1.5 -7.15625,-2.625 -2.1875,-1.132813 -4.195313,-2.507813 -6.015625,-4.125 -1.8125,-1.625 -3.546875,-3.429687 -5.203125,-5.421875 l -1.09375,6.859375 c -0.398437,1.71875 -1.074219,2.945313 -2.03125,3.671875 C 31.273438,-0.363281 29.96875,0 28.3125,0 H 12.109375 V -147.59375 H 36.65625 Z m 0,0",
    id: "path20"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g26",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(459.64462,263.42064)",
    id: "g25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 35.265625,-84.21875 c 3.175781,-6.09375 6.945313,-10.878906 11.3125,-14.359375 4.375,-3.476565 9.539063,-5.218755 15.5,-5.218755 4.695313,0 8.46875,1.03125 11.3125,3.09375 L 71.8125,-82.34375 c -0.335938,1.199219 -0.820312,2.046875 -1.453125,2.546875 -0.625,0.492187 -1.46875,0.734375 -2.53125,0.734375 -0.992187,0 -2.464844,-0.160156 -4.421875,-0.484375 -1.949219,-0.332031 -3.851562,-0.5 -5.703125,-0.5 -2.710937,0 -5.125,0.398437 -7.25,1.1875 -2.117187,0.792969 -4.015625,1.933594 -5.703125,3.421875 -1.6875,1.492188 -3.179688,3.296875 -4.46875,5.421875 -1.292969,2.117187 -2.5,4.53125 -3.625,7.25 V 0 H 12.109375 v -101.90625 h 14.40625 c 2.519531,0 4.273437,0.44922 5.265625,1.34375 0.988281,0.898438 1.648438,2.5 1.984375,4.8125 z m 0,0",
    id: "path23"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g29",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.73397,263.42064)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 36.65625,-147.59375 v 84.53125 h 4.5625 c 1.65625,0 2.960938,-0.210938 3.921875,-0.640625 0.957031,-0.4375 1.9375,-1.316406 2.9375,-2.640625 l 25.3125,-31.28125 c 1.0625,-1.394531 2.238281,-2.45703 3.53125,-3.1875 1.289063,-0.72656 2.960937,-1.09375 5.015625,-1.09375 h 22.45313 L 72.703125,-64.0625 c -2.25,2.980469 -4.699219,5.265625 -7.34375,6.859375 1.382813,0.992187 2.625,2.148437 3.71875,3.46875 1.09375,1.324219 2.132813,2.746094 3.125,4.265625 L 106.17188,0 H 84.03125 C 82.101562,0 80.441406,-0.3125 79.046875,-0.9375 77.660156,-1.570312 76.503906,-2.71875 75.578125,-4.375 L 49.5625,-43 c -0.929688,-1.53125 -1.890625,-2.523438 -2.890625,-2.984375 -0.992187,-0.46875 -2.476563,-0.703125 -4.453125,-0.703125 h -5.5625 V 0 H 12.109375 v -147.59375 z m 0,0",
    id: "path26"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g32",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(639.90222,263.42064)",
    id: "g31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.265625,0 V -83.421875 L 10.421875,-84.8125 C 8.503906,-85.21875 6.96875,-85.898438 5.8125,-86.859375 c -1.15625,-0.957031 -1.734375,-2.332031 -1.734375,-4.125 v -10.031255 h 15.1875 v -7.54687 c 0,-5.82031 0.875,-11.05078 2.625,-15.6875 1.757813,-4.63281 4.273437,-8.57031 7.546875,-11.8125 3.28125,-3.25 7.269531,-5.73437 11.96875,-7.45312 4.707031,-1.71875 10.007812,-2.57813 15.90625,-2.57813 4.695312,0 9.066406,0.625 13.109375,1.875 l -0.5,12.32813 c -0.0625,0.92968 -0.328125,1.67187 -0.796875,2.23437 -0.460938,0.5625 -1.074219,0.99609 -1.84375,1.29688 -0.761719,0.29296 -1.636719,0.49218 -2.625,0.59374 -0.992188,0.0937 -2.046875,0.14063 -3.171875,0.14063 -2.917969,0 -5.523437,0.32031 -7.8125,0.95312 -2.28125,0.625 -4.21875,1.71485 -5.8125,3.26563 -1.585937,1.55469 -2.792969,3.60547 -3.625,6.15625 C 43.410156,-114.69531 43,-111.53516 43,-107.76563 v 6.75 h 26.53125 v 17.48438 H 43.796875 V 0 Z m 0,0",
    id: "path29"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g35",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(711.11142,263.42064)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 74.296875,-82.03125 c -0.667969,1.054688 -1.367187,1.796875 -2.09375,2.234375 -0.730469,0.429687 -1.65625,0.640625 -2.78125,0.640625 -1.1875,0 -2.464844,-0.328125 -3.828125,-0.984375 -1.355469,-0.664063 -2.929688,-1.410156 -4.71875,-2.234375 -1.78125,-0.832031 -3.820312,-1.578125 -6.109375,-2.234375 -2.28125,-0.664063 -4.976563,-1 -8.078125,-1 -4.835938,0 -8.625,1.027344 -11.375,3.078125 -2.75,2.054688 -4.125,4.734375 -4.125,8.046875 0,2.179687 0.707031,4.011719 2.125,5.5 1.425781,1.492187 3.316406,2.804687 5.671875,3.9375 2.351563,1.125 5.019531,2.136719 8,3.03125 2.976563,0.886719 6.003906,1.859375 9.078125,2.921875 3.082031,1.0625 6.113281,2.273438 9.09375,3.625 2.976562,1.355469 5.640625,3.078125 7.984375,5.171875 2.351563,2.085937 4.242187,4.585937 5.671875,7.5 1.425781,2.90625 2.140625,6.414063 2.140625,10.515625 0,4.90625 -0.882813,9.429688 -2.640625,13.5625 -1.75,4.136719 -4.351562,7.714844 -7.796875,10.734375 C 67.078125,-4.972656 62.820312,-2.625 57.75,-0.9375 52.6875,0.75 46.84375,1.59375 40.21875,1.59375 c -3.511719,0 -6.9375,-0.320312 -10.28125,-0.953125 -3.34375,-0.625 -6.558594,-1.5 -9.640625,-2.625 -3.074219,-1.125 -5.917969,-2.445313 -8.53125,-3.96875 -2.617187,-1.53125 -4.917969,-3.1875 -6.90625,-4.96875 l 5.671875,-9.34375 c 0.726562,-1.125 1.585938,-1.984375 2.578125,-2.578125 0.988281,-0.59375 2.25,-0.890625 3.78125,-0.890625 1.519531,0 2.957031,0.433594 4.3125,1.296875 1.351563,0.855469 2.925781,1.78125 4.71875,2.78125 1.789063,0.992188 3.894531,1.917969 6.3125,2.78125 2.414063,0.855469 5.476563,1.28125 9.1875,1.28125 2.90625,0 5.398437,-0.34375 7.484375,-1.03125 2.09375,-0.695312 3.816406,-1.609375 5.171875,-2.734375 1.351563,-1.132813 2.34375,-2.445313 2.96875,-3.9375 C 57.679688,-24.785156 58,-26.320312 58,-27.90625 c 0,-2.382812 -0.714844,-4.335938 -2.140625,-5.859375 -1.417969,-1.519531 -3.304687,-2.84375 -5.65625,-3.96875 -2.34375,-1.132813 -5.027344,-2.144531 -8.046875,-3.03125 -3.011719,-0.894531 -6.089844,-1.875 -9.234375,-2.9375 -3.148437,-1.0625 -6.226563,-2.300781 -9.234375,-3.71875 -3.011719,-1.425781 -5.695312,-3.226563 -8.046875,-5.40625 -2.355469,-2.1875 -4.246094,-4.867187 -5.671875,-8.046875 -1.417969,-3.1875 -2.125,-7.03125 -2.125,-11.53125 0,-4.164062 0.828125,-8.132812 2.484375,-11.90625 1.65625,-3.78125 4.085937,-7.078125 7.296875,-9.890625 3.21875,-2.8125 7.222656,-5.0625 12.015625,-6.750005 4.800781,-1.6875 10.347656,-2.53125 16.640625,-2.53125 7.019531,0 13.410156,1.15625 19.171875,3.46875 5.757813,2.312505 10.5625,5.35938 14.40625,9.14063 z m 0,0",
    id: "path32"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g38",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(798.40972,263.42064)",
    id: "g37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 46.078125,1.59375 c -8.867187,0 -15.667969,-2.5 -20.40625,-7.5 -4.730469,-5 -7.09375,-11.90625 -7.09375,-20.71875 v -56.90625 h -10.4375 c -1.324219,0 -2.449219,-0.425781 -3.375,-1.28125 C 3.835938,-85.675781 3.375,-86.96875 3.375,-88.6875 v -9.734375 l 16.390625,-2.687505 5.15625,-27.81249 c 0.332031,-1.32032 0.960937,-2.34766 1.890625,-3.07813 0.925781,-0.72656 2.117188,-1.09375 3.578125,-1.09375 h 12.71875 v 32.07812 H 70.3125 v 17.48438 H 43.109375 v 55.21875 c 0,3.1875 0.773437,5.679688 2.328125,7.46875 1.550781,1.78125 3.6875,2.671875 6.40625,2.671875 1.519531,0 2.789062,-0.179687 3.8125,-0.546875 1.03125,-0.363281 1.925781,-0.742188 2.6875,-1.140625 0.769531,-0.394531 1.453125,-0.773437 2.046875,-1.140625 0.59375,-0.363281 1.1875,-0.546875 1.78125,-0.546875 0.726563,0 1.320313,0.183594 1.78125,0.546875 0.46875,0.367188 0.96875,0.90625 1.5,1.625 l 7.34375,11.921875 c -3.574219,2.980469 -7.679687,5.234375 -12.3125,6.765625 -4.636719,1.519531 -9.4375,2.28125 -14.40625,2.28125 z m 0,0",
    id: "path35"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrkfstLogo);
export default __webpack_public_path__ + "static/media/brkfst-logo.0a0f4ecec7fb95ad184e31e334534f02.svg";
export { ForwardRef as ReactComponent };